import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridPreset } from "@store/Framework/Types/Grid";
import { gridGapStyles } from "@store/Themes/common/mixins/grid";

export const getGridPresetStyles = (preset: GridPreset) => {
    return gridGapStyles(preset.horizontal, preset.vertical);
};

export const getGridPreset = (preset: GridPreset): GridContainerProps => ({
    gap: 0,
    css: getGridPresetStyles(preset),
});
